export default __webpack_public_path__ + "static/media/done.36a97654.svg";